import { analyticsService } from 'utils/services/analytics'

export const FlowPickerAnalytics = {
  logOpenFlowPickerModal: () => analyticsService.sendEvent('CMS.FLOW_PICKER_MODAL.OPENED'),
  logCloseFlowPickerModal: () => analyticsService.sendEvent('CMS.FLOW_PICKER_MODAL.CLOSED'),
}
